module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-plus plus",
    on: {
      "click": function($event) {
        _vm.addNote()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-star",
    class: [{
      starred: _vm.isCurrentFavourite
    }, {
      star: _vm.isCurrentActiveAccessible
    }, {
      disabled: !_vm.isCurrentActiveAccessible
    }],
    attrs: {
      "disabled": _vm.isCurrentActiveAccessible ? false : true
    },
    on: {
      "click": function($event) {
        _vm.toggleFavourite()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-remove",
    class: [{
      remove: _vm.isCurrentActiveAccessible
    }, {
      disabled: !_vm.isCurrentActiveAccessible
    }],
    attrs: {
      "disabled": _vm.isCurrentActiveAccessible ? false : true
    },
    on: {
      "click": _vm.deleteNote
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-off signOut bottom",
    on: {
      "click": _vm.signOut
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76abd76c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 118
// module chunks = 2